import { fetchGet, toQueryString } from "../../../../service/api_client";
import { POListFilter } from "../../purchase_order_list/purchase_order_list";


export const getPurchaseOrderListDataRepo = async (props: POListFilter) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/prev-purchase-order`;
  const res = await fetchGet(url + toQueryString(props));
  return res;
};